// 搜尋空值
import Image from "next/image";

const EmptyResult = ({ t }) => {
  return (
    <div className="w-full py-[80px] text-center text-black mx-auto">
      <div className="img-box w-[94px] h-[94px] after:content-none mx-auto">
        <Image
          className="dark:filter-white"
          src="/images/icon/icon_empty.svg"
          width={94}
          height={94}
          alt="no_result"
        />
      </div>
      <p className="text-bd2n mt-[30px] mb-[10px]">{t("NO_RESULT")}</p>
      <p className="text-bd1n">{t("RETRY")}</p>
    </div>
  );
};

export default EmptyResult;
